import { makeVar, ReactiveVar } from '@apollo/client'

import { ITourDate, ITourDateCountryCodes } from 'shared/interfaces'

export const TourDatesStore = {
  tourDates: {
    read: () => tourDatesVar()
  },
  countryList: {
    read: () => countryCodeListVar()
  }
}

export const tourDatesVar: ReactiveVar<ITourDate[]> = makeVar<ITourDate[]>([])
export const countryCodeListVar: ReactiveVar<ITourDateCountryCodes[]> = makeVar<ITourDateCountryCodes[]>([])
